export const contactsData = {
  email: 'zunairkhan811@gmail.com',
  phone: '+923316838401',
  address: 'House No. 2035/9, Area Kiri Afghan outside Lohari Gate Multan, Pakistan',

  sheetAPI: '',
};
